<template>
  <section>
    <v-card>
      <v-card-text class="py-0">
        <v-layout
          row
          wrap
          align-center
          justify-space-around
          fill-height
          class="pt-1 pb-2"
        >
          <v-flex shrink>
            <span class="blue--text font-weight-bold"
              >DEPENDIENTES: {{ l_dependientes.length }}</span
            >
          </v-flex>
          <v-flex shrink>
            <span class="blue--text font-weight-bold"
              >JEFE: {{ l_jefe.length > 0 ? "SI" : "NO" }}</span
            >
          </v-flex>
          <v-flex shrink>
            <span class="blue--text font-weight-bold"
              >TOTAL PERSONAL: {{ l_personas.length }}</span
            >
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center class="mb-2">
          <v-flex
            xs12
            sm4
            md3
            v-for="persona in l_jefe"
            :key="persona.id_persona"
          >
            <ItemSliderComponent
              :persona="persona"
              :key="persona.id_persona"
              class="contenedor-jefe"
              :campos_personales="campos_personales"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap align-space-around justify-center fill-height>
          <v-flex
            xs12
            sm4
            md3
            v-for="persona in l_dependientes"
            :key="persona.id_persona"
          >
            <ItemSliderComponent
              :persona="persona"
              :key="persona.id_persona"
              id="content-card"
              :campos_personales="campos_personales"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import ItemSliderComponent from "./ItemSliderComponent.vue";
export default {
  // Variables iniciales
  props: ["id_unidad", "filtros_persona", "campos_personales"],
  components: { ItemSliderComponent },
  data() {
    return {
      l_personas: [],
      l_dependientes: [],
      l_jefe: {}
    };
  },
  computed: {},
  watch: {
    filtros_persona: {
      handler: async function(newVal, oldVal) {
        await this.cargarPersonas();
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    await this.cargarPersonas();
  },
  mounted() {},
  methods: {
    async cargarPersonas() {
      this.l_personas = await this.$query.select(
        "v_lista_personal_activo",
        { id_unidad: this.id_unidad, ...this.filtros_persona },
        [
          "id_persona",
          "nro_doc",
          "ap_paterno",
          "ap_materno",
          "nombres",
          "nro_item",
          "puesto",
          "cargo",
          "foto",
          "nombre_unidad",
          "nivel_jerarquia"
        ]
      );
      //Buscamos el jefe y sus dependientes 5:dependientes, resto:jefes
      this.l_dependientes = this.l_personas.filter(
        ele => ele.nivel_jerarquia == 5
      );
      this.l_jefe = this.l_personas.filter(ele =>
        [1, 2, 3, 4].includes(parseInt(ele.nivel_jerarquia))
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.contenedor-jefe {
  box-shadow: 0px 0px 30px 5px rgba(50, 207, 255, 0.733);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reportes_lista_personal/components/EstructuraUnidad.vue